<div nz-flex [nzVertical]="true" class="bg-white p-10">
  <nz-row nzGutter="24" class="rows displayFlex">
    <nz-col nzSpan="24" class="w-100">
      <nz-tabset nzCentered id="reportTabs">
        <nz-tab nzTitle="{{ reportTitle.summary }}">
          <app-track-mx-summary
            [trackMXSummaryResponse]="trackMXSummaryResponse"
            [reportData]="reportData"
          ></app-track-mx-summary>
        </nz-tab>
        <nz-tab nzTitle="{{ reportTitle.vareq }}">
          <app-track-mx-vareq
            [trackMXVareQResponse]="trackMXVareQResponse"
            [reportData]="reportData"
          ></app-track-mx-vareq>
        </nz-tab>
        <nz-tab nzTitle="{{ reportTitle.var }}">
          <app-track-mx-var
            [trackMXVarResponse]="trackMXVarResponse"
            [reportData]="reportData"
          ></app-track-mx-var>
        </nz-tab>
        <nz-tab nzTitle="{{ reportTitle.vareqVariance }}">
          <app-track-mx-vareq-variance
            [trackMXVareQVarianceResponse]="trackMXVareQVarianceResponse"
            [reportData]="reportData"
          ></app-track-mx-vareq-variance>
        </nz-tab>
        <nz-tab nzTitle="{{ reportTitle.varVariance }}">
          <app-track-mx-var-variance
            [trackMXVarVarianceResponse]="trackMXVarVarianceResponse"
            [reportData]="reportData"
          ></app-track-mx-var-variance>
        </nz-tab>
      </nz-tabset>
    </nz-col>
  </nz-row>
</div>
